import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environment/environment';
import { AdviDTO } from '../../../../dto/advi/advi.dto';

export const advisoryDetail = (dataSourceService: any) => {
  return {
    name: 'advisoryDetail',
    description: 'Get single advisory details',
    execute: (params?: any): Observable<AdviDTO> => {
      const id = params?.id;
      if (!id) {
        throw new Error('Advisory ID is required');
      }
      
      return (dataSourceService.http as HttpClient).get<AdviDTO>(
        `${environment.apiUrl}/advi/${id}`
      );
    }
  };
};
